import { getParameters } from '../../../helpers/helpers';
import { CUSTOMER_FORM } from './form-customer-types';

import HandleNewCustomerForm from './addNewCustomer/handle-new-cust-form';
import GetIndividualCustomer from './displayCustomer/get-customer-info';
import UpdateCustomer from './updateCustomer/update-customer';

/**
 * Directs form functionality base on createCustomer para
 * 
 * @returns void
 */
export const formCustomer = () => {
  if ( !CUSTOMER_FORM.customerFormContainer ) return;

  const formAction = getParameters('createCustomer');

  if( formAction ) {
    HandleNewCustomerForm();
  } else {
    GetIndividualCustomer();
    UpdateCustomer();
  } 
}